import { generatePath } from 'react-router';

import { PATHS } from '@/shared/config';

type ConsultationPathParams = {
  patientID: string;
  consultationID: string;
};

export const getConsultationPath = ({
  patientID,
  consultationID,
}: ConsultationPathParams): string =>
  `${generatePath(PATHS.consultation, { patientID })}?tab=summary&id=${consultationID}`;
